import React from 'react';

interface BasicDetailsProps {
  form: { roleName: string; roleCategory: string; roleDescription: string; template: string };
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
  handleTemplateClick: (template: string) => void;
}

const roleCategories = ['Admin', 'Manager', 'Editor', 'Viewer'];
const quickTemplates = [
  { title: 'Admin', desc: 'Full management access' },
  { title: 'Manager', desc: 'Department oversight' },
  { title: 'Editor', desc: 'Content management' },
  { title: 'Viewer', desc: 'Read-only access' },
];

const BasicDetails: React.FC<BasicDetailsProps> = ({ form, handleChange, handleTemplateClick }) => {
  return (
    <div>
      {/* Form Section */}
      <div>
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Basic Information</h2>
        <p className="text-sm text-gray-500 mb-6">Enter the basic details for a new role</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-600">Role Name</label>
            <input
              type="text"
              name="roleName"
              value={form.roleName}
              onChange={handleChange}
              placeholder="Enter Role Name"
              className="w-full p-2 mt-1 border rounded-md focus:ring-2 focus:ring-pink-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600">Role Category</label>
            <select
              name="roleCategory"
              value={form.roleCategory}
              onChange={handleChange}
              className="w-full p-2 mt-1 border rounded-md focus:ring-2 focus:ring-pink-500"
            >
              <option value="">Select Category</option>
              {roleCategories.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-600">Role Description</label>
          <textarea
            name="roleDescription"
            value={form.roleDescription}
            onChange={handleChange}
            placeholder="Describe the purpose and responsibilities of this role"
            className="w-full p-2 mt-1 border rounded-md focus:ring-2 focus:ring-pink-500"
            rows={3}
          />
        </div>

        {/* Quick Templates */}
        <div className="mb-6">
          <h3 className="text-sm font-medium text-gray-600 mb-2">Quick Start Templates</h3>
          <p className="text-xs text-gray-500 mb-3">
            Choose a template to pre-configure permissions (you can customise in the next steps)
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {quickTemplates.map((template, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleTemplateClick(template.title)}
                className={`p-3 rounded-lg text-left shadow-sm border transition ${
                  form.template === template.title
                    ? 'bg-pink-600 text-white'
                    : 'bg-blue-100 text-gray-800 hover:bg-blue-200'
                }`}
              >
                <span className="block font-semibold">{template.title}</span>
                <span className="text-xs">{template.desc}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
